import dynamic from 'next/dynamic';

export const ProductCardV2AvailabilityOverlayDynamic = dynamic(
  () =>
    import('./ProductCardV2.AvailabilityOverlay.client').then(
      (mod) => mod.ProductCardV2AvailabilityOverlay,
    ),
  { ssr: false },
);
